/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractVariantDto } from '../../models/backend-leasing-contract-variant-dto';
import { BackendLeasingContractVariantRequestDto } from '../../models/backend-leasing-contract-variant-request-dto';

export interface FinancingSourcesLeasingsVariantsUpdate$Params {
  /**
   * A unique integer value identifying this leasing contract variant.
   */
  id: number;
  body: BackendLeasingContractVariantRequestDto;
}

export function financingSourcesLeasingsVariantsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsVariantsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsVariantsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractVariantDto>;
    }),
  );
}

financingSourcesLeasingsVariantsUpdate.PATH = '/api/financing_sources/leasings_variants/{id}/';
